'use client';

import { type ReactElement } from 'react';
import { cn } from '@fshr/shared-react';
import { IconChevronLightLeft, IconChevronLightRight } from '../icon';

type Props = {
	canScrollPrev: boolean;
	canScrollNext: boolean;
	onPrev: () => void;
	onNext: () => void;
	imageHeightClass: string;
	imageHeight: number;
	labels: { previous: string; next: string };
	bleed?: 'always' | 'below-lg' | 'never';
};

const buttonClass =
	'flex h-500 w-500 cursor-pointer items-center justify-center rounded-full bg-white shadow-[0px_5px_7.5px_rgba(3,3,3,0.12)] transition-transform duration-300 hover:scale-110 focus-visible:outline-2 focus-visible:outline-offset-2';

export default function CarouselArrows({
	canScrollPrev,
	canScrollNext,
	onPrev,
	onNext,
	imageHeightClass,
	imageHeight,
	labels,
	bleed = 'never',
}: Props): ReactElement {
	return (
		<div
			className={cn(
				'pointer-events-none absolute inset-x-0 top-0 z-20 hidden items-center justify-between opacity-0 transition-opacity duration-300 group-hover:opacity-100 md:flex',
				bleed === 'always' && 'spacing-wide-grid-bleed',
				bleed === 'below-lg' && 'max-lg:spacing-wide-grid-bleed',
				imageHeightClass
			)}
			style={imageHeight > 0 ? { height: imageHeight } : undefined}
		>
			<button
				type="button"
				onClick={onPrev}
				aria-label={labels.previous}
				className={cn(
					buttonClass,
					'ml-inline-xs',
					canScrollPrev ? 'pointer-events-auto' : 'invisible'
				)}
			>
				<IconChevronLightLeft width={20} height={20} />
			</button>
			<button
				type="button"
				onClick={onNext}
				aria-label={labels.next}
				className={cn(
					buttonClass,
					'mr-inline-xs',
					canScrollNext ? 'pointer-events-auto' : 'invisible'
				)}
			>
				<IconChevronLightRight width={20} height={20} />
			</button>
		</div>
	);
}
